import styled from 'styled-components';
import { colors } from '../../../../../assets';

export const WrapperTable = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const Table = styled.table`
	font-size: 1rem;
`;

export const Thead = styled.thead`
	color: ${colors.primaryBlue};
	background: ${colors.background};
	font-weight: bold;
	height: 3.75rem;

	tr {
		color: ${colors.primaryBlue};

		th {
			display: flex;
			justify-content: center;
			align-items: center;
			text-align: center;
			border-left: 1px solid ${colors.borderTable};
			height: 100%;
			padding: 10px;
		}

		th:last-child {
			border-right: 1px solid ${colors.borderTable};
		}
	}
`;

export const Tr = styled.tr`
	min-height: 3.75rem;
	align-items: center;
	display: grid;

	grid-template-columns: ${({ columnEntry }) =>
		columnEntry &&
		`minmax(5.625rem, 13rem)
		 minmax(5.625rem, 14.1875rem)
		 minmax(5.625rem, 15rem)
		 minmax(5.625rem, 21rem)
		 minmax(5.625rem, 15.4375rem)
		 minmax(5.625rem, 11rem)
		 minmax(5.625rem, 13rem)`};
	grid-template-columns: ${({ columnOut }) =>
		columnOut &&
		`minmax(5.625rem, 13rem)
		 minmax(5.625rem, 14.1875rem)
		 minmax(5.625rem, 14.625rem)
		 minmax(5.625rem, 20.875rem)
		 minmax(5.625rem, 15.4375rem)
		 minmax(5.625rem, 11.8750rem)
		 minmax(5.625rem, 13rem)`};
	grid-template-columns: ${({ columnOut, columnEntry }) =>
		!columnOut &&
		!columnEntry &&
		`minmax(5.625rem, 15rem)
		 minmax(5.625rem, 17rem)
		 minmax(5.625rem, 17rem)
		 minmax(5.625rem, 21rem)
		 minmax(5.625rem, 18rem)
		 minmax(5.625rem, 15rem)
		 `};
	grid-template-columns: ${({ columnOut, columnEntry }) =>
		columnOut &&
		columnEntry &&
		`minmax(5.625rem, 11rem)
		minmax(5.625rem, 12.1875rem)
		 minmax(5.625rem, 13rem)
		 minmax(5.625rem, 19rem)
		 minmax(5.625rem, 11rem)
		 minmax(5.625rem, 13.4375rem)
		 minmax(5.625rem, 12rem)
		 minmax(5.625rem, 11rem)`};
	color: ${colors.white};
	${({ top, bottom }) =>
		top
			? `border-top: 1px solid ${colors.borderTable};`
			: bottom && `border-bottom: 1px solid ${colors.borderTable}`};

	td:last-child {
		border-right: 1px solid ${colors.borderTable};
	}
`;

export const Td = styled.td`
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
	border-left: 1px solid ${colors.borderTable};
	padding: 10px;
	height: 100%;
	color: ${({ blue }) => blue && colors.primaryBlue};
	font-weight: 400;

	${({ blue, clicavel }) =>
		clicavel
			? `cursor: pointer;
		text-decoration: none;

		:hover {
			text-decoration: underline;
		}`
			: blue && 'pointer-events: none'};
`;

export const Tbody = styled.tbody`
	tr {
		:nth-child(odd) {
			background: ${colors.gridBlack};
		}
		:nth-child(even) {
			background: ${colors.rowTable};
		}
	}

	tr:first-child {
		margin-top: -2px;
	}
`;

export const Data = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	flex-wrap: wrap;

	p.data {
		font-size: 1rem;
		line-height: 0.9375rem;
		margin-top: 0;
		padding: 0;
	}

	p.bold {
		font-weight: 600;
	}

	svg.seta-curva-icon {
		height: 1.25rem;
		width: 1.25rem;
	}

	span {
		height: 0.9375rem;
	}
`;

export const Row = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 5px;
	width: 100%;

	svg.plus-icon {
		width: 0.75rem;
		height: 0.75rem;
	}

	svg.minus-icon {
		width: 0.75rem;
		height: 0.75rem;
	}

	p.total {
		color: ${({ sinal }) => (sinal === '+' ? colors.green : colors.primaryRed)};
	}
`;

export const Empty = styled.div`
	flex: 1;
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
	height: 100px;
	border: 1px solid ${colors.borderTable};
	border-top: none;
	margin-top: -2px;
	padding: 0 1.5rem;

	span {
		color: ${colors.white};
		font-size: 1rem;
		font-weight: 300;
		font-family: Jost;
	}
`;
